<template>
  <a-modal title="Filters" width="600px" :visible="visible" @cancel="cancel" :destroy-on-close="true" v-if="visible">
    <div class="grid">
      <b class="col-4">Start Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.start_date"
        valueFormat="YYYY-MM-DD"
        placeholder="Start Date"
        @change="handleStartDateChange('start_date', 'end_date')"
      />

      <b class="col-4">End Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.end_date"
        valueFormat="YYYY-MM-DD"
        placeholder="End Date"
        ref="endDatePicker"
        @change="handleEndDateChange('start_date', 'end_date')"
        :open="isEndDatePickerOpen"
        :default-picker-value="getEndDateDefaultPickerValue('start_date')"
        @openChange="handleEndDateOpenChange"
      />

      <a-radio-group class="w-full" v-model="filters.is_negative" button-style="solid">
        <a-radio-button class="col-4 p-0 text-center" :value="undefined"> All </a-radio-button>
        <a-radio-button class="col-4 p-0 text-center" :value="true"> Negative </a-radio-button>
        <a-radio-button class="col-4 p-0 text-center" :value="false"> Positive </a-radio-button>
      </a-radio-group>

      <template v-if="!disabledFilters">
        <span class="col-12"></span>

        <b class="col-4">Category</b>
        <custom-select
          class="col-8"
          :multiple="true"
          :value.sync="filters.types"
          placeholder="Category"
          :options="types"
          name="type_name"
          optionKey="type"
          @change="handleTypeChange" />

        <template v-if="filters.types.length">
          <b class="col-4">Event</b>
          <custom-select
            class="col-8"
            :multiple="true"
            :value.sync="filters.sub_types"
            placeholder="Event"
            :options="subtypes.filter(item => filters.types.includes(item.type))"
            name="sub_type_name"
            optionKey="sub_type" /></template
      ></template>
    </div>
    <template slot="footer">
      <div class="flex justify-content-end">
        <a-button type="danger" :disabled="isEmptyFilters" @click="reset"> Reset </a-button>
        <a-button type="primary" @click="apply"> Apply </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select.vue'
import { deepCopy } from '@/utils/deep-copy'
import { DatePicker, Modal, Radio } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import LinkedDateFilterMixin from '@/mixins/linkedDateFilterMixin'

const { mapState: pointSystemState } = createNamespacedHelpers('pointSystem')
const { mapState: profileState } = createNamespacedHelpers('profile')

const filtersBaseState = Object.freeze({
  end_date: undefined,
  start_date: undefined,
  sub_types: [],
  types: [],
  is_negative: undefined
})

export default {
  mixins: [LinkedDateFilterMixin],
  components: {
    'a-date-picker': DatePicker,
    'a-radio-group': Radio.Group,
    'a-radio-button': Radio.Button,
    'a-modal': Modal,
    'custom-select': CustomSelect
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentFilters: {
      type: Object,
      required: true
    }
  },
  data() {
    return { filters: { ...filtersBaseState } }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.filters = {
            ...filtersBaseState,
            ...deepCopy(this.currentFilters)
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    }),
    ...pointSystemState({
      subtypes: state => state.types
    }),

    disabledFilters() {
      return !this.associate?.point_system?.point_system_status?.is_show_points
    },

    isEmptyFilters() {
      return JSON.stringify(filtersBaseState) === JSON.stringify(this.filters)
    },

    types() {
      return Array.from(
        new Map((this.subtypes ?? []).map(item => [item.type, { type: item.type, type_name: item.type_name }])).values()
      )
    }
  },
  methods: {
    handleTypeChange(value) {
      this.filters.sub_types = this.filters.sub_types.filter(item => {
        const element = this.subtypes.find(el => el.sub_type === item)

        if (element && value.includes(element.type)) {
          return true
        } else {
          return false
        }
      })
    },
    reset() {
      if (this.isEmptyFilters) {
        this.cancel()
      } else {
        this.filters = deepCopy(filtersBaseState)
        this.$emit('update:currentFilters', this.filters)
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    },

    apply() {
      this.cancel()

      this.$emit('update:currentFilters', this.filters)
    }
  }
}
</script>

<style scoped>
.ant-calendar-picker {
  margin: 0;
}
</style>
